<template lang="pug">
div
  //screen-title(title="vouchers.settings_title")
  .box
    h3.title.is-4 {{$t('vouchers.online_sales_title')}}
    b-field(:label="$t('vouchers.title_label')" :type="errors.has('title') ? 'is-danger': ''"  :message="errors.has('title') ? errors.first('title') : ''")
      b-input(v-model="vouchers.title" name="title" v-validate="'required'" :placeholder="$t('vouchers.title_placeholder')")
    b-field(:label="$t('vouchers.online_sales_label')" :type="errors.has('validity') ? 'is-danger': ''"  :message="errors.has('pricePresets') ? errors.first('pricePresets') : ''")
      b-taginput(
        v-model="vouchers.pricePresets"
        name="pricePresets"
        ellipsis
        type="is-black"
        icon="tag-outline"
        :placeholder="$t('vouchers.price_preset_placeholder')"
        aria-close-label="Delete this tag"
        :before-adding="beforeAddingPricePreset"
        v-validate="'required'"
      )
        template(slot="tag" slot-scope="props")
          currency-view(:value="Number(props.tag)")
    b-field(:message="$t('vouchers.expiration_description')")
      b-field(:label="$t('vouchers.valid_label')" grouped group-multiline)
        b-field( :type="errors.has('validity') ? 'is-danger': ''" :message="errors.has('validity') ? errors.first('validity') : ''")
          b-input(v-model="vouchers.defaultValidity"  v-validate="'required|numeric'" name="validity" :placeholder="$t('vouchers.valid_placeholder')")
        b-field( :type="errors.has('validityUnit') ? 'is-danger': ''" :message="errors.has('validityUnit') ? errors.first('validityUnit') : ''")
          b-select(v-model="vouchers.defaultValidityUnit" v-validate="'required'" name="validityUnit" data-vv-as="unit" )
            option(v-for="value in validityUnits" :value="value") {{$t(`misc.${value}`)}}
    b-field(:label="$t('vouchers.terms_label')")
      b-input(v-model="vouchers.terms" type="textarea" :placeholder="$t('vouchers.notes_placeholder')")
  .box
    
    .columns
      .column
        .card-preview-controls.mb-4
          h3.title.is-4 {{$t('vouchers.templates_title')}}
          .field
            label.label(v-t="'vouchers.card_style_label'")
            .control
              b-field(grouped)
                b-radio(v-model="vouchers.stylePreset.cardStyle" native-value="rectangle") {{$t('vouchers.style_rectangle')}}
                b-radio(v-model="vouchers.stylePreset.cardStyle" native-value="rounded") {{$t('vouchers.style_rounded')}}
              b-field.mt-2
                b-checkbox(v-model="vouchers.stylePreset.showCutOut") {{$t('vouchers.style_cut_outs')}}

          .field
            label.label(v-t="'vouchers.style_font_label'")
            .control
              b-select(v-model="vouchers.stylePreset.fontFamily")
                option(value="Arial, sans-serif") Arial
                option(value="Helvetica, sans-serif") Helvetica
                option(value="Verdana, sans-serif") Verdana
                option(value="Tahoma, sans-serif") Tahoma
                option(value="'Trebuchet MS', sans-serif") Trebuchet MS
                option(value="'Times New Roman', serif") Times New Roman
                option(value="Georgia, serif") Georgia
                option(value="Garamond, serif") Garamond
                option(value="'Courier New', monospace") Courier New
                option(value="'Comic Sans MS', cursive") Comic Sans MS

          .field
            label.label(v-t="'vouchers.style_font_color_label'")
            .control
              .d-flex.align-items-center
                b-radio.mr-4(v-model="vouchers.stylePreset.fontColor" native-value="#FFFFFF") {{$t('vouchers.style_font_color_white')}}
                b-radio.mr-4(v-model="vouchers.stylePreset.fontColor" native-value="#000000") {{$t('vouchers.style_font_color_black')}}
                b-colorpicker.ml-2(v-model="vouchers.stylePreset.fontColor" expanded)

          .field
            label.label(v-t="'vouchers.style_colors_label'")
            .gradient-presets
              .gradient-preset(
                v-for="(preset, index) in colorPresets" 
                :key="index"
                :class="{ active: isCurrentPreset(preset) }"
                :style="getPresetStyle(preset)"
                @click="selectPreset(preset)"
              )
              .gradient-preset.custom-preset(
                :class="{ active: isCustomSelected }"
                @click="selectCustom"
              )
                span(v-t="'vouchers.style_colors_custom'")
            
            .custom-colors(v-if="isCustomSelected")
              b-field(grouped)
                .color-picker
                  label.mr-2(v-t="'vouchers.style_gradient_start'")
                  b-colorpicker(v-model="vouchers.stylePreset.gradientStart")
                .color-picker
                  label.mr-2(v-t="'vouchers.style_gradient_end'")
                  b-colorpicker(v-model="vouchers.stylePreset.gradientEnd")
          b-field
            b-field
              b-checkbox(v-model="vouchers.stylePreset.showLogo" :disabled="!company.logo") {{$t('vouchers.style_show_logo')}}
            b-field(v-if="vouchers.stylePreset.showLogo")
              b-radio(v-model="vouchers.stylePreset.logoColor" native-value="original") {{$t('vouchers.style_logo_original')}}
              b-radio(v-model="vouchers.stylePreset.logoColor" native-value="white") {{$t('vouchers.style_logo_white')}}
              b-radio(v-model="vouchers.stylePreset.logoColor" native-value="black") {{$t('vouchers.style_logo_black')}}
      .column
        h3.title.is-4.has-text-centered {{$t('vouchers.preview_title')}}
        GiftCardPreview(:value="voucherTemplate" :stylePreset="vouchers.stylePreset" scope="client")
  .box
    b-field(:label="$t('vouchers.simple_label')" :message="vouchers.isSimple ? $t('vouchers.simple_help'): $t('vouchers.not_simple_help')" )
      b-radio(v-model="vouchers.isSimple" name="isSimple" :native-value="true") {{$t('vouchers.is_simple_value')}}
      b-radio(v-model="vouchers.isSimple" name="isSimple" :native-value="false") {{$t('vouchers.is_not_simple_value')}}
    b-field(:label="$t('vouchers.prefix_label')" v-if="vouchers.isSimple")
      b-input(v-model="vouchers.prefix" icon="tag-outline" :placeholder="$t('vouchers.prefix_placeholder')")
    .field
      p {{$t('vouchers.sample_code')}} 
        span.has-text-weight-semibold {{sampleCode}}
  .field.pb-6
    .control
      action-button(:loading="submitting" @click="submit" title="actions.save")
</template>
<script>
import {mapState} from 'vuex'
import GiftCardPreview from '../shared/GiftCardPreview.vue'
import dayjs from 'dayjs'
import {cloneDeep} from 'lodash'
export default {
  name: 'VouchersSettings',
  components: {
    GiftCardPreview
  },
  data() {
    return {
      submitting: false,
      validityUnits: ['days', 'weeks', 'months'],
      vouchers: {
        prefix: undefined,
        isSimple: undefined,
        defaultValidity: 3,
        defaultValidityUnit: 'months',
        terms: undefined,
        pricePresets: [],
        title: undefined,
        stylePreset: {
          cardStyle: 'rectangle',
          gradientStart: '#4A90E2',
          gradientEnd: '#50E3C2',
          showLogo: true,
          logoColor: 'white',
          showCutOut: false,
          fontFamily: "'Trebuchet MS', sans-serif",
          fontColor: '#FFFFFF'
        }
      },

      isCustomSelected: false,
      colorPresets: [
        ['#4A90E2', '#50E3C2'],
        ['#FF6B6B', '#FFE66D'],
        ['#6C5CE7', '#A8E6CF'],
        ['#2D3436', '#636E72'],
        ['#11998E', '#38EF7D']
      ],
      message: undefined
    }
  },
  computed: {
    ...mapState('company', ['company']),
    sampleCode() {
      if (this.vouchers.isSimple) {
        return `${this.vouchers.prefix ? this.vouchers.prefix : ''}1234`
      }
      return '6I20KA4HCD'
    },
    voucherTemplate() {
      return {
        title: this.vouchers.title,
        terms: this.vouchers.terms,
        value: Number(this.vouchers.pricePresets[0] || 0),
        remaining: Number(this.vouchers.pricePresets[0] || 0),
        price: Number(this.vouchers.pricePresets[0] || 0),
        expire: dayjs()
          .add(this.vouchers.defaultValidity, this.vouchers.defaultValidityUnit)
          .toDate(),
        specificServices: false,
        services: [],
        code: 'H38H37KL1',
        message: this.vouchers.message || this.$t('vouchers.example_message')
        //"Dear Sarah,\nThank you for being such an amazing friend. I hope you'll enjoy this gift card for a relaxing spa day!\nBest wishes,\nEmma"
      }
    }
  },
  created() {
    if (this.company.vouchers) {
      let currentSettings = cloneDeep(this.company.vouchers)
      if (!currentSettings.stylePreset) {
        currentSettings.stylePreset = this.vouchers.stylePreset
      }
      Object.assign(this.vouchers, currentSettings)
    }
    if (!this.vouchers.title) {
      this.vouchers.title = this.$t('vouchers.name_initial_value')
    }
  },
  methods: {
    beforeAddingPricePreset(tag) {
      if (this.vouchers.pricePresets.includes(tag)) {
        return false
      }
      if (isNaN(tag)) {
        return false
      }
      if (tag < 0) {
        return false
      }
      return true
    },
    async submit() {
      const valid = await this.$validator.validateAll()
      if (!valid || this.submitting) {
        return
      }
      this.submitting = true
      this.vouchers.pricePresets = this.vouchers.pricePresets.map(Number)
      const data = {
        vouchers: this.vouchers,
        _updateType: 'vouchers'
      }
      try {
        await this.$store.dispatch('company/update', data)
        this.$buefy.toast.open({message: this.$t('status.save_success'), type: 'is-success', queue: false})
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    },
    getPresetStyle(preset) {
      return {
        background: `linear-gradient(to right, ${preset[0]}, ${preset[1]})`
      }
    },

    isCurrentPreset(preset) {
      return (
        !this.isCustomSelected &&
        this.vouchers.stylePreset.gradientStart === preset[0] &&
        this.vouchers.stylePreset.gradientEnd === preset[1]
      )
    },

    selectPreset(preset) {
      this.isCustomSelected = false
      this.vouchers.stylePreset.gradientStart = preset[0]
      this.vouchers.stylePreset.gradientEnd = preset[1]
    },

    selectCustom() {
      this.isCustomSelected = true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-preview-controls {
  .color-picker {
    margin-right: 1rem;
  }
}

.gradient-presets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.gradient-preset {
  height: 48px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &.active {
    border-color: #485fc7;
    box-shadow: 0 0 0 2px rgba(72, 95, 199, 0.2);
  }

  &.custom-preset {
    background: #f5f5f5;
    border: 2px dashed #dbdbdb;

    span {
      color: #363636;
      font-size: 0.9rem;
      font-weight: 500;
    }

    &:hover {
      background: #eeeeee;
    }

    &.active {
      background: #485fc7;
      border-style: solid;
      border-color: #485fc7;

      span {
        color: white;
      }
    }
  }
}

.custom-colors {
  margin-top: 1rem;
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 6px;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.mr-4 {
  margin-right: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}
</style>
